import { SelectProps } from "antd";
import { StyledSelect } from "./atom.js";
import { ConfigProvider } from "antd";
import i18next from "i18next";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";

export function Select({
  className = "",
  allowClear = true,
  ...props
}: SelectProps) {
  return (
    <ConfigProvider
      locale={i18next.language === "zh" ? zhCN : enUS}
      theme={{
        token: {
          colorText: "#FFFFFF",
        },
      }}
    >
      <StyledSelect
        className={`renderbus-ui--select ${className}`}
        allowClear={allowClear}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        {...props}
      />
    </ConfigProvider>
  );
}

Select.Option = StyledSelect.Option;
